<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="700" scrollable>
			<v-card>
				<v-card-title class="text-h6">List Serial {{ name }}</v-card-title>
        <v-alert v-for="(msg, index) in message" :key="index" v-model="msg.show" dense dismissible type="error" elevation="1">
          {{msg.msg}}
        </v-alert>
				<v-card-text class="pb-1" v-for="(serialType, indexserial) in serial_type" :key="indexserial">
					<div class="pb-3 text-body-1 text-center" v-if="false">Silahkan Scan Serial di sini</div>
					<div class="pb-3 d-flex justify-center" v-if="false">
						<div class="col-12 col-sm-10 p-4 container-scanner">
							<img class="scan-icon-top-left" src="/assets/icon/scan-icon.png">
							<QrcodeStream @decode="onDecode"></QrcodeStream>
							<img class="scan-icon-bot-right" src="/assets/icon/scan-icon.png">
						</div>
					</div>
					<div class="d-flex">
						<v-col cols="12" sm="12" class="px-0">
							<v-text-field dense outlined label="Kode Serial" clearable autofocus hide-details="auto" @keypress.enter="checkSerial(serialType)" v-model="serialType.serial" ref="inputSerial" append-icon="mdi-magnify" @click:append="checkSerial(serialType)"></v-text-field>
							<div v-show="false">Belum ada serial dipilih</div>
						</v-col>
					</div>
					<v-col class="pt-0 px-0">
            <div class="font-weight-bold">Serial {{serialType.serial_name}} {{serialType.serial_array.length}} dari {{serialType.quantity * quantity}}</div>
						<v-row>
							<v-col cols="4" v-for="(item, index) in serialType.serial_array" :key="index">
								<span class="pr-1">{{item}}</span>
								<v-btn fab dark x-small depressed color="pink" @click="removeSerial(indexserial, index)">
									<v-icon dark>mdi-delete</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
export default {
	data () {
		return {
			dialog: false,
			message: [],
			serial: '',
			serialScan: [],
		}
	},
	components: {
		QrcodeStream
	},
	props: {
		value: Boolean,
		edit: String,
		name: String,
    quantity: Number,
		serial_type: {
      type: Array,
      default: function () {
        return []
      }
    },
	},
	methods: {
		checkSerial(serial) {
			this.saveSerial(serial)
			this.serial = ''
		},
		removeSerial(indexserial, index) {
			this.serial_type[indexserial].serial_array.splice(index, 1)
		},
		showModal () {
			this.message = []
			this.serialScan = []
			this.serial = ''
			this.dialog = true
		},
		onDecode(val) {
			if (val) {
				this.$emit('scanLink', val)
			}
		},
		hideModal (){
			this.dialog = false
		},
		showMessage(msg) {
			this.message = msg
		},
		saveSerial(serial) {
			if (serial.serial) {
				this.$emit('saveSerial', serial)
			}
		},
	},
	watch: {
	},
};
</script>
